import { Divider } from '@mui/material';

import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

export const EditMaxCLASkeleton = () => (
  <>
    <SectionSkeleton height={160} width={435} />
    <Divider />
    <SectionSkeleton height={50} width={435} />
  </>
);
